import React, { useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { Form } from "react-bootstrap";
import { RiCloseFill } from "react-icons/ri";
import IconUpload from "../images/dashboard/icon-upload.png";
import IconWord from "../images/dashboard/icon-word.png";
import IconPdf from "../images/dashboard/icon-pdf.png";
import IconExcel from "../images/dashboard/icon-excel.png";

const fileTypeIcons = {
    pdf: IconPdf,
    doc: IconWord,
    docx: IconWord,
    csv: IconExcel,
    xls: IconExcel,
    xlsx: IconExcel,
};

const fileTypeLabels = {
    "text/csv": "csv",
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "",
    "application/pdf": "PDF and Word",
};

const DocumentUpload = ({ formik, name, acceptedTypes, label = "Upload Document*", fileUrl = '' }) => {
    const [file, setFile] = useState(null);
    const onDrop = (acceptedFiles) => {
        if (acceptedFiles.length > 0) {
            setFile(acceptedFiles[0]);
            formik.setFieldValue(name, acceptedFiles[0]);
            formik.setFieldTouched(name, true); // Mark the field as touched
        }
    };
    useEffect(() => {
        if (typeof fileUrl === 'string' && fileUrl) {
            setFile({ name: fileUrl.split("/").pop() || "Unnamed File", url: fileUrl });
        }
    }, [fileUrl]);
    const handleRemoveFile = () => {
        setFile(null);
        formik.setFieldValue(name, "");
        formik.setFieldTouched(name, true);
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: false,
        accept: acceptedTypes,
    });

    const readableFileTypes = Object.keys(acceptedTypes)
        .map((type) => fileTypeLabels[type] || "")
        .filter(Boolean)
        .join(", ") + " file";

    return (
        <Form.Group className="h-100 d-flex flex-column">
            <Form.Label>{label}</Form.Label>
            <div
                {...getRootProps({
                    className: "dropzone p-3 text-center d-flex align-items-center justify-content-between flex-grow-1",
                })}
                style={{
                    borderRadius: "8px",
                    border: "2px dashed #677289",
                    minHeight: "100px",
                }}
            >
                <input {...getInputProps()} />
                {file ? (
                    <div className="d-flex flex-column w-100 position-relative">
                        <div className="d-flex align-items-start" style={{ width: "100%" }}>
                            <img
                                src={fileTypeIcons[file.name.split(".").pop()] || IconUpload}
                                className="me-2 flex-shrink-0"
                                alt="icon"
                                width={30}
                                style={{ marginTop: "2px" }}
                            />
                            <div className="fw-normal text-dark mb-0" style={{ 
                                textAlign: 'left',
                                flex: 1,
                                minWidth: 0,
                                paddingRight: '10px'
                            }}>
                                {file.url ? (
                                    <a href={file.url} target="_blank" className="text-dark text-decoration-none fw-normal"
                                        style={{ 
                                            fontSize: "14px",
                                            display: "block",
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere",
                                            lineHeight: "1.4"
                                        }} rel="noopener noreferrer">
                                        {file.name}
                                    </a>
                                ) : (
                                    <span style={{
                                        display: "block",
                                        wordBreak: "break-word",
                                        overflowWrap: "anywhere",
                                        lineHeight: "1.4",
                                        fontSize: "14px"
                                    }}>
                                        {file.name}
                                    </span>
                                )}
                                {!fileUrl && <span className="w-100 d-block fw-normal text-light">
                                    {(file.size / 1024 / 1024).toFixed(2)} MB
                                </span>}
                            </div>
                            <RiCloseFill
                                size={25}
                                onClick={handleRemoveFile}
                                className="ms-2 bg-transparent border-0 position-absolute"
                                style={{ cursor: "pointer", right: '-13px', top: '-10px' }}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="text-center w-100">
                        <img src={IconUpload} alt="icon" />
                        <p className="mb-0 text-light fw-bold" style={{ fontSize: "14px" }}>
                            Drag & Drop or <span className="text-primary">Choose file</span> to upload
                        </p>
                        <p className="mb-0 text-light">{readableFileTypes}</p>
                    </div>
                )}
            </div>
            {formik.touched[name] && formik.errors[name] && (
                <div className="text-danger mt-2">{formik.errors[name]}</div>
            )}
        </Form.Group>
    );
};

export default DocumentUpload;
